import React from 'react';
import { useIntl } from 'react-intl';
import { StyledNavButton, StyledNavIconWrapper } from '../../styled/StyledNavButton';
import { locales } from '../../helpers/site';
import FlagIcon from '../FlagIcon';
import rentalcoverSharedMessages from '../../helpers/messages/commonMsg';

interface ILocaleButtonMobileProps {
  toggle: () => void;
}

export const LocaleButtonMobile = ({ toggle }: ILocaleButtonMobileProps) => {
  const { locale, formatMessage } = useIntl();

  const toggleLocaleModal = () => {
    toggle();
  };

  return (
    <StyledNavButton onClick={toggleLocaleModal} buttonType="tertiary" $spaceBetween>
      <div className="locale-button-nav-item">
        <StyledNavIconWrapper className="nav-icon-wrapper" $withRounding>
          <FlagIcon locale={locales[locale].xcode} alt={`Selected Language: ${locales[locale].name}`} />
        </StyledNavIconWrapper>
        <p className="language-nav-text">{formatMessage(rentalcoverSharedMessages.languageNavItemText)}</p>
      </div>
      <p className="locale-button-text">{locales[locale].nameLocal}</p>
    </StyledNavButton>
  );
};
